module.exports = __webpack_public_path__ + "static/media/parallax-form-3.0300c58c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/common/parallax/parallax-form-3.svg
// module id = 688
// module chunks = 146